import {Outlet} from "react-router-dom";
import {Toaster} from "react-hot-toast";

export const Layout = () => {
  return (
    <>
      <div><Toaster/></div>
      <div className="max-w-2xl mx-auto my-16">
        <Outlet/>
      </div>
    </>
  )
}
